<template>
  <section>
    <div
      class="section with-border section-row div-5"
      :class="{ dirty }"
    >
      <div class="row-label double-f">
        Taxes
      </div>
      <div>
        <Form
          :form-id="TAXES_FORM_ID"
          :initial-values="{ taxPercentage }"
        >
          <VPPercentageInput
            ref="taxesRef"
            :disabled="disabled"
            input-id="taxPercentage"
            placeholder="Add taxes"
            class="right-field"
            hide-empty-input
            @blur="taxSave"
          />
        </Form>
      </div>
      <div class="right-field">
        -
      </div>
      <div class="right-field">
        {{ formatCurrency(taxAmount, { onZero: '-' }) }}
      </div>
    </div>
    <div class="section with-border section-row div-5">
      <div class="field-title double-f">
        Net Potential (After Taxes)
      </div>
      <div class="right-field">
        -
      </div>
      <div class="right-field">
        -
      </div>
      <div class="right-field overflow-x-auto">
        {{ formatCurrency(netPotential, { onZero: '-' }) }}
      </div>
    </div>
    <div class="section section-row div-5 bold">
      <div class="triple-f">
        Total cap
      </div>
      <div class="right-field">
        {{ totalCapTickets }}
      </div>
      <div class="right-field overflow-x-auto">
        {{ formatCurrency(totalCapAmount, { onZero: '-' }) }}
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useOfferSheetStore } from '@/stores/offer-sheet';
import { useOfferSheetFormStore, TAXES_FORM_ID } from '@/stores/offer-sheet-form';
import { formatCurrency } from '@/helpers/currency';
import { Form, useFormsStore } from 'vuniform';
import VPPercentageInput from '@/components/form/VPPercentageInput.vue';

const taxesRef = ref<VPPercentageInput>(null);

const offerSheetStore = useOfferSheetStore();
const offerSheetFormStore = useOfferSheetFormStore();
const formsStore = useFormsStore();
const offerSheet = computed(() => offerSheetStore.offerSheet);

const taxPercentage = computed(() => offerSheetStore.offerSheet?.taxPercentage);
const totalCapTickets = computed(() => offerSheetFormStore.totalCapTickets);
const totalCapAmount = computed(() => offerSheetFormStore.totalCapAmount);
const taxAmount = computed(() => offerSheetFormStore.taxAmount);
const netPotential = computed(() => offerSheetFormStore.netPotential);
const loading = computed(() => offerSheetStore.offerSheetLoading);

const dirty = computed(() => formsStore.isFormDirty(TAXES_FORM_ID));

const taxSave = async () => {
  if (loading.value || !formsStore.isFieldDirty(TAXES_FORM_ID, 'taxPercentage')) {
    return;
  }

  await offerSheetStore.updateOfferSheet(
    {
      id: offerSheetStore.offerSheet.id,
      taxPercentage: offerSheetFormStore.taxPercentage,
    },
    ['taxPercentage'],
  );

  formsStore.SET_INITIAL_VALUES({
    values: { ...offerSheet.value },
    formId: TAXES_FORM_ID,
    clearDirty: true,
  });
};
</script>
